<template>
    <van-tabs class="data-cnt" v-model:active="tabActive" color="#07c160">
      <van-tab name="desc" title="数据说明">
        <article id="content" class="article-content" tabindex="0" style="outline-style: none;">
          <div class="ne-doc-major-viewer">
              <div class="yuque-doc-content" data-df="lake" style="position: relative;">
                  <div>
                      <div class="ne-viewer lakex-yuque-theme-light ne-typography-classic ne-paragraph-spacing-relax ne-viewer-layout-mode-fixed"
                           data-viewer-mode="normal" id="u5f1b">
                          <div class="ne-viewer-body">
                            <ne-oli index-type="0" v-for="(scene,index) in sceneOptions" :key="index">
                              <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"
                                              style="color: rgb(0, 0, 0);"><span>{{index+1}}</span></span></ne-oli-i>
                              <ne-oli-c class="ne-oli-content" id="ub05c2e9a" data-lake-id="ub05c2e9a">
                                <ne-text id="u57cc81b8" ne-bold="true" style="color: rgb(0, 0, 0);">{{ scene.text }}:</ne-text>
                                <ne-text id="u62ed35b1" style="color: rgb(0, 0, 0);">{{scene.gifts.join("-")}}礼物的数量(括号内为所有飘屏人民币总价值),出{{scene.resetNum}}个{{scene.gifts[0]}}之后数据重置</ne-text>
                                <span class="ne-viewer-b-filler" ne-filler="block"><br></span></ne-oli-c>
                            </ne-oli>
                            <ne-oli index-type="0">
                              <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"><span>{{sceneOptions.length+1}}</span></span>
                              </ne-oli-i>
                              <ne-oli-c class="ne-oli-content" id="ud42ae12e" data-lake-id="ud42ae12e">
                                <ne-text id="ua05cf6fe" ne-bold="true" style="color: rgb(0, 0, 0);display:flex;"><ClipbordComponent :show-content="true" btn-text="QQ群号复制" :text="qqGroupId" show-copy-button="true"/></ne-text>
                                <span class="ne-viewer-b-filler" ne-filler="block"></span></ne-oli-c>
                            </ne-oli>
                            <ne-oli v-if="downloadUrl" index-type="0">
                              <ne-oli-i><span class="ne-list-symbol" data-type="0" data-level="0"><span>{{sceneOptions.length+2}}</span></span>
                              </ne-oli-i>
                              <ne-oli-c class="ne-oli-content" id="ud42ae12e" data-lake-id="ud42ae12e">
                                <ne-text id="ua05cf6fe" ne-bold="true" style="color: rgb(0, 0, 0);display:flex;">
                                  <ClipbordComponent :show-content="true" :btn-text="`${platformName}下载地址`" :text="downloadUrl" show-copy-button="true"/>
                                  <span>&nbsp;&nbsp;<a target="_blank" :href="downloadUrl"><van-button size="small" type="primary">下载</van-button></a></span>
                                </ne-text>

                              </ne-oli-c>
                            </ne-oli>
                          </div>
                          <div class="ne-inner-overlay-container">
                              <ne-overlay-tmp contenteditable="false" data-event-boundary="overlay">
                                  <div class="count-tips-module_tipsContainer___5agc"></div>
                              </ne-overlay-tmp>
                          </div>
                      </div>
                      <div style="height: 0px; overflow: hidden;"></div>
                  </div>
              </div>
          </div>
        </article>
      </van-tab>
      <van-tab name="query" title="数据查询">
        <van-dropdown-menu>
          <van-dropdown-item v-model="queryType" :options="queryOptions"/>
          <van-dropdown-item v-model="sceneTye" :options="sceneOptions" />
        </van-dropdown-menu>
        <van-search v-if="queryType==='gift'"
            v-model="searchKeyword"
            show-action
            placeholder="请输入礼物名称或价值"
                    @search="doQueryData"
        ><template #action>
          <div style="display:flex;">
            <van-checkbox size="small" v-model="filterSmallVal">过滤边角料</van-checkbox>
            <van-button type="primary" size="small" @click="doQueryData">搜索</van-button>
          </div>
        </template>
        </van-search>
        <ul v-if="user.maxtMemberAuth">
          <li class="gift-record" v-for="(record,index) in pageData.items" :key="index">
            <div class="gift-user" v-if="queryType==='gift'">{{record.user}}</div>
            <div class="gift-time">{{record.time.substring(5)}}</div>
            <div class="gift-name" v-if="queryType==='gift'">{{record.giftName + "(" + record.val + ")"}}x{{record.num}}</div>
            <div class="gift-scene" v-if="queryType==='history'">{{sceneMap[record.scenne]}}</div>
            <div class="gift-data" v-if="queryType==='history'">{{record.msg}}</div>
          </li>
        </ul>
        <div v-else>
          <p class="van-color-danger">数据查询功能为白银会员专享<router-link to="/pay">
            <van-button size="small" type="danger">购买会员</van-button>
          </router-link></p>
        </div>

        <van-pagination v-model="currentPage" :show-page-size="3"
                        force-ellipses :total-items="pageData.totalCount"
                        :items-per-page="pageData.pageSize" />
      </van-tab>
      <van-tab name="broadcast" title="数据机器人" badge="新">
        <div class="content-wrap">
          <div class="line-text" v-if="!supportRobot">
            <span class="text-danger">{{platformName}}数据机器人正在开发中，需要加急请联系客服(QQ群:{{qqGroupId}})。</span>
          </div>
          <div class="broadcast-header">
            <van-icon name="info-o" size="1rem" color="#999" />
            <span class="header-text">在房间公屏播报飘屏数据</span>
            <van-button size="small" type="primary" @click="openAddRoomDialog" class="add-room-btn">添加房间</van-button>
          </div>
          
          <div class="room-cards">
            <div v-for="(roomItem, index) in robotConfig.rooms" :key="index" class="room-card">
              <div class="room-top room-row">
                <div class="room-index">#{{roomItem.roomIndex !== undefined ? roomItem.roomIndex : index}}</div>
                <div class="text-danger" v-if="!(roomItem.status && roomItem.expire && roomItem.expire > format(new Date(), 'yyyy-MM-dd H:mm:ss'))">
                  <van-icon name="clear"/>
                  <template v-if="!roomItem.status">推送开关关闭</template>
                  <template v-else>订阅已过期</template>
                </div>
                <div class="top-button-wrap">
                  <van-button size="small" type="success" class="edit-btn" @click="openEditRoomDialog(roomItem)">修改</van-button>
                  <van-button size="small" type="danger" class="renew-btn" @click="routeTo('/robot-pay?room=' + (roomItem.roomIndex !== undefined ? roomItem.roomIndex : index) + '&platform=' + (robotConfig.platform || dataType))">续费</van-button>
                </div>
              </div>
              <div class="room-row">
                <span class="row-label">房间ID</span>
                <span class="row-value">
                  <van-tag v-if="roomItem.room" type="info" :plain="false">{{roomItem.room}}</van-tag>
                  <span v-else>--</span>
                </span>
              </div>
              <div class="room-row">
                <span class="row-label">推送开关</span>
                <van-icon :name="roomItem.status ? 'checked' : 'clear'" :color="roomItem.status ? '#07c160' : '#FF4081'" size="1.2rem" />
              </div>
              <div class="room-row">
                <span class="row-label">到期时间</span>
                <span class="row-value expire-value" :class="{'expired': !roomItem.expire || roomItem.expire <= format(new Date(), 'yyyy-MM-dd H:mm:ss')}">{{roomItem.expire || '--'}}</span>
              </div>
              <div class="room-row games-row">
                <span class="row-label">播报玩法</span>
                <div class="games-list">
                  <template v-if="roomItem.games.length > 0">
                    <van-tag type="info" :plain="false" v-for="game in roomItem.games" :key="game">{{game}}</van-tag>
                  </template>
                  <span v-else>--</span>
                </div>
              </div>
            </div>
            <span v-if="!robotConfig.rooms || robotConfig.rooms.length === 0" class="no-room">暂无房间配置</span>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-dialog class="robot-config" :title="null" :show="showEditRobotDialog" :show-confirm-button="false">
      <div class="dialog-header"><span class="text-tip">#{{currentRoom.roomIndex}}</span> {{isEditMode ? '房间配置' : '添加房间'}}</div>
      
      <Field v-model="currentRoom.room" type="text" placeholder="房间ID" label="房间ID" />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><label>推送开关</label></div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="currentRoom.status" />
          </div>
        </div><!----><!---->
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><label>播报玩法</label></div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <van-checkbox-group v-model="currentRoom.games" class="game-list-wrap">
              <van-checkbox v-for="sceneOption in sceneOptions" :name="sceneOption.text" :key="sceneOption.value">{{sceneOption.text}}</van-checkbox>
            </van-checkbox-group>
          </div>
        </div><!----><!---->
      </div>
      
      <div class="button-wrap">
        <van-button size="small" @click="showEditRobotDialog=false">取消</van-button>
        <van-button size="small" type="primary" @click="saveRoom">保存</van-button>
      </div>
    </van-dialog>
</template>

<style lang="less">
@import "@/app.less";

.data-cnt{
  --van-badge-background: @color2;
}

.article-content{
    text-align: left;
}

[ne-bold]{
    font-weight: 700;
}
ne-oli-i .ne-list-symbol {
    padding-right: 6px;
    font-family: @font;
}

ne-oli, ne-tli, ne-uli {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    padding-left: 2em;
}

ne-oli-i, ne-tli-i, ne-uli-i {
    min-width: 2em;
    margin-left: -2em;
    text-indent: 0;
    padding-left: 0;
    display: inline-flex;
    justify-content: flex-end;
    -moz-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    box-sizing: border-box;
    white-space: nowrap;
}

ne-oli-i .ne-list-symbol:after {
    content: ".";
}

ne-oli-c, ne-tli-c, ne-uli-c {
    text-indent: 0;
    padding-left: 0;
    min-width: 1px;
}

.ne-paragraph-spacing-relax.ne-typography-classic ne-oli, .ne-paragraph-spacing-relax.ne-typography-classic ne-tli, .ne-paragraph-spacing-relax.ne-typography-classic ne-uli {
    margin-bottom: 3.915px;
}


.data-cnt{
  --van-pagination-item-default-color: @color11;

  .van-cell__title{
    width: 6rem;
    color: @black1;
  }

  .van-field__control{
    color: #666;
  }
  .gift-record{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    flex-wrap: nowrap;
    flex-direction: row;
    padding: 0.2rem 1rem;
    .gift-time{
      width: 6rem;
      padding: 0 0.5rem;
      color: #666;
      white-space: nowrap;
      text-align: left;
    }

    .gift-scene{
      padding: 0 0.5rem;
      width: 4rem;
      white-space: nowrap;
    }

    .gift-user{
      width: 7rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: left;
    }

    .gift-name,.gift-scene{
      color: @color11;
    }
  }

  .van-color-danger{
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  .van-pagination__item{
    color: @black1;
  }
  .van-pagination__item--active{
    color: @white;
  }

  .content-wrap{
    padding: 0;
    .van-tag{
      height: 1.5rem;
      margin: 0 0.2rem;
    }
  }

}
.robot-config{
  .van-field__label{
    width: 4rem;
  }
  .dialog-header{
    text-align: center;
    padding: 1rem;
    font-weight: bold;
    font-size: 1rem;
    color: @black1;
    text-align: left;
  }
  .button-wrap{
    display: flex;
    justify-content: space-evenly;
  }

  .game-list-wrap{
    display: flex;
    flex-wrap: wrap;
    .van-checkbox{
      flex: auto;
      height: 1.5rem;
    }
  }

  .room-config-list{
    max-height: 50vh;
    overflow-y: auto;
  }
  .room-config-item{
    border: 1px solid #ebedf0;
    border-radius: 8px;
    margin: 0.5rem 1rem;
    padding: 0.5rem 0;
    .room-config-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1rem 0.5rem 1rem;
      font-weight: bold;
      color: @black1;
      border-bottom: 1px solid #f5f5f5;
      margin-bottom: 0.5rem;
    }
  }
  .add-room-group{
    margin: 0.5rem 1rem;
    .room-index-text{
      color: #666;
      font-size: 0.9rem;
    }
  }
}

.broadcast-header{
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  .header-text{
    flex: 1;
    margin-left: 0.5rem;
    color: var(--van-gray-6);
    text-align: left;
  }
  .add-room-btn{
    background: @color2;
    border-color: @color2;
  }
}

.room-cards{
  padding: 0 0.5rem;
}
.room-card{
  border: 1px solid #ebedf0;
  border-radius: 12px;
  padding: 0.8rem;
  margin-bottom: 0.8rem;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  .room-index{
    color: #999;
    margin-bottom: 0.5rem;
    text-align: left;
  }

  .room-row{
    display: flex;
    align-items: center;
    margin-bottom: 0.6rem;
    &.room-top{
      justify-content: space-between;
      .top-button-wrap{
        margin: 0;
        button{
          margin: 0 0.5rem;
        }
      }
    }
    .row-label{
      width: 4.5rem;
      font-size: var(--van-font-size-md);
      color: var(--van-gray-7);
      flex-shrink: 0;
      text-align: left;
    }
    .row-value{
      font-size: 0.9rem;
    }
    .room-id-value{
      background: #333;
      color: #fff;
      padding: 0.3rem 0.8rem;
      border-radius: 6px;
      font-size: 0.9rem;
      text-align: center;
      max-width: 8rem;
    }
    .expire-value{
      color: @color11;
      font-size: 0.9rem;
      &.expired{
        color: @color2;
      }
    }
    .push-label{
      margin-left: 1.5rem;
    }
    .edit-btn{
      margin-left: auto;
    }
    .renew-btn{
      margin-left: auto;
    }
  }
  .games-row{
    margin-bottom: 0;
    .games-list{
      display: flex;
      flex-wrap: wrap;
      gap: 0.4rem;
      .game-tag{
        background: #000;
        color: #fff;
        padding: 0.3rem 0.8rem;
        border-radius: 6px;
        font-size: 0.85rem;
      }
    }
  }
}
.no-room{
  color: #999;
  padding: 1rem;
  text-align: center;
  display: block;
}

</style>
<script>
import {Button, Field, showToast} from "vant";
import store from "@/store";
import {onMounted, ref, watch} from "vue";
import ClipbordComponent from "@/components/Clipbord.vue";
import API from "@/api";
import RobotPay from "@/views/pay/RobotPay.vue";
import {useRouter} from "vue-router";
import {format} from "date-fns";

const platformDownloadUrlMap = {};

export default {
    name: 'DefaultDataDesc',
    components: {Field, RobotPay, ClipbordComponent, Button},
    props: ['dataType'],
    setup(props){
        const qqGroupId = "1031191163";
        const router = useRouter();

        const routeTo = (path) => router.push(path)

        const showBuyRobotDialog = ref(false);
        const showEditRobotDialog = ref(false);
        const newRoom = ref({ room: '', status: true, games: [] });
        const isEditMode = ref(false);
        const currentRoom = ref({ roomIndex: 0, room: '', status: true, games: [] });
        const userStore = store.userStore();
        const deviceId = store.userStore().getDeviceId();
        const showDownloadQRC = ref(false);
        const robotConfig = ref({
          platform: props.dataType,
          fromPlatform: "0",
          expire: format(new Date(), 'yyyy-MM-dd H:mm:ss'),
          realStatus:false,
          status: true,
          room: null,
          rooms: [],
          switchPlatforms:[],
          games: []
        });
      const dataType = props.dataType || 'taqu';


      const robotConfigForm = ref(Object.assign({platform: dataType, rooms: [], games:[]}, robotConfig.value));

        const tabActive = ref("desc");
        const queryOptions = [
            {text: "礼物记录", value:"gift"},
            {text: "统计结果", value:"history"},
        ];
        const downloadUrl = ref(platformDownloadUrlMap[dataType]);
        const refSceneMap = ref({});
        const sceneOptions = ref([]);
        const queryType = ref("gift");
        const sceneTye = ref("");
        const searchKeyword = ref("");
        const pageData = ref({items:[], totalCount:0, pageSize: 20});
        const platformName = ref("");
        const supportRobot = ref(false);

        const robotStatus = ref(false);

        API.data.queryGameDataBase({dataType}).then((res)=>{
          if(res.success){
            sceneOptions.value = res.data.giftSceneOptions;
            refSceneMap.value = res.data.sceneMap;
            platformName.value = res.data.platformName;
            sceneTye.value = res.data.defaultGiftScene;
            supportRobot.value = res.data.supportRobot;
          }else{
            // showToast(res.errorMsg);
          }
        });

      const filterSmallVal = ref(true);

      const currentPage = ref(1);
      const user = userStore.user;

      const doQueryGift = async (value) => {
        const res = await API.data.queryGift({
          deviceId: userStore.getDeviceId(),
          scene: sceneTye.value,
          giftName: searchKeyword.value,
          dataType: dataType,
          pageNo: currentPage.value,
          minVal: filterSmallVal.value ? 100:0,
          showYoloPay: user.maxtMemberAuth.memberType === 'silver'
        });

        if(res.success){
          pageData.value = res.data;
        }else{
          showToast(res.errorMsg);
        }
      };

        const doQueryHistory = async (value) => {
          const res = await API.data.queryHistory({
            deviceId: userStore.getDeviceId(),
            scene: sceneTye.value,
            dataType: dataType,
            pageNo: currentPage.value
          });

          if(res.success){
            pageData.value = res.data;
          }else{
            showToast(res.errorMsg);
          }
        };

        const doQueryData = () => {
          if(queryType.value === "gift"){
            doQueryGift()
          }else{
            doQueryHistory()
          }
        };

      onMounted(() => {
        watch([queryType,sceneTye,searchKeyword], () => {
          if(tabActive.value === "query"){
            doQueryData();
          }
        });

        watch(tabActive,(value) => {
          console.log("tabActive",value);
          if(value === "query"){
            doQueryData();
          }

          if(value === "broadcast"){
            API.data.getRobotConfig({deviceId, dataType}).then(res => {
              if(res.success){
                const data = res.data || {};
                // 兼容旧数据：顶层 room + games → rooms[0]
                if((!data.rooms || data.rooms.length === 0) && data.room){
                  data.rooms = [{
                    roomIndex: 0,
                    room: String(data.room),
                    robotRoomId: data.robotRoomId,
                    expire: data.expire,
                    status: data.status,
                    games: data.games || []
                  }];
                }
                robotConfig.value = Object.assign({platform: dataType, rooms: [], games:[]},robotConfig.value, data);
                robotConfigForm.value = Object.assign({platform: dataType, rooms: [], games:[]}, robotConfig.value);
              }else{
                // showToast(res.errorMsg);
              }
            });
          }
        })

        watch(currentPage, () => {
          doQueryData();
        })

      });
      return {
          robotConfigForm,
          robotConfig,
          newRoom,
          isEditMode,
          currentRoom,
          showBuyRobotDialog,
          showEditRobotDialog,
          qqGroupId,
          deviceId,
          showDownloadQRC,
          tabActive,
          queryOptions,
          sceneOptions,
          queryType,
          sceneTye,
          searchKeyword,
          pageData,
          currentPage,
          sceneMap:refSceneMap,
          doQueryData,
          downloadUrl,
          platformName,
          filterSmallVal,
          robotStatus,
          user: userStore.user,
          supportRobot:supportRobot,
          routeTo,
        }
    },
    methods: {
      format,
      openEditRoomDialog(roomItem){
        this.isEditMode = true;
        this.currentRoom = Object.assign({}, roomItem);
        this.showEditRobotDialog = true;
      },
      openAddRoomDialog(){
        this.isEditMode = false;
        const nextIndex = this.robotConfigForm.rooms && this.robotConfigForm.rooms.length > 0
          ? Math.max(...this.robotConfigForm.rooms.map(r => r.roomIndex !== undefined ? r.roomIndex : -1)) + 1
          : 0;
        this.currentRoom = { roomIndex: nextIndex, room: '', status: true, games: [] };
        this.showEditRobotDialog = true;
      },
      saveRoom(){
        const room = this.currentRoom;
        if(!room.room || !room.room.trim()){
          showToast("请输入房间ID");
          return;
        }
        if(!this.robotConfigForm.rooms){
          this.robotConfigForm.rooms = [];
        }

        const validNames = this.sceneOptions.map(opt => opt.text);
        console.log(room.games,validNames);
        room.games = room.games.filter(val => validNames.includes(val));



        if(this.isEditMode){
          const idx = this.robotConfigForm.rooms.findIndex(r => r.roomIndex === room.roomIndex);
          if(idx !== -1){
            Object.assign(this.robotConfigForm.rooms[idx], room);
          }
        }else{
          if(this.robotConfigForm.rooms.some(r => r.roomIndex === room.roomIndex)){
            showToast("房间序号已存在");
            return;
          }
          this.robotConfigForm.rooms.push(Object.assign({}, room));
        }
        
        this.doSaveRobotConfig();
      },
      doSaveRobotConfig(){
        const _self = this;

        if(!_self.robotConfigForm.platform){
          _self.robotConfigForm.platform = _self.dataType;
        }
        // 清理空房间
        _self.robotConfigForm.rooms = (_self.robotConfigForm.rooms || []).filter(r => r.room && r.room.trim());
        // 兼容旧接口：主房间取 rooms 第一个
        const rooms = _self.robotConfigForm.rooms || [];
        _self.robotConfigForm.room = rooms.length > 0 ? rooms[0].room : null;
        _self.robotConfigForm.games = rooms.length > 0 ? rooms[0].games : [];
        
        API.data.doSaveRobotConfig(_self.robotConfigForm).then((res) => {
          if(res.success){
            showToast("保存成功");
            _self.robotConfigForm.fromPlatform = null;
            _self.showEditRobotDialog = false;
            this.robotConfig = Object.assign({}, res.data)
          }else{
            showToast(res.errorMsg);
          }
        });
      }
    }
}
</script>
